export interface ILocalization {
  [key: string]: string;
}
export interface ISectionProps {
  imageUrl: string;
  sectionId: number;
  topic: ILocalization;
  description?: string;
  subSections: ISubsectionProps[];
}

export interface ISubsectionProps {
  label: ILocalization;
  value: string;
  imageUrl?: string;
  articles?: IArticlesProps[];
  isFeatureList?: boolean;
}

interface IArticlesProps {
  label: ILocalization;
  value: string;
  imageUrl?: string;
}

export enum IHelpCentreTopics {
  GENERAL_ENQUIRIES = "Setel FAQ",
  MY_ACCOUNTS_AND_DEVICE = "Account and password",
  PAYMENTS = "Payment and top-up",
  MESRA_RELATED = "Mesra membership",
  PROMOTION_AND_REWARDS = "Promotions and rewards",
  REPORT_A_PROBLEM = "Report a problem",
  FUELLING = "fuelling",
}

export interface IArticleProps {
  id: number | string;
  url: string;
  html_url: string;
  author_id: number;
  comments_disabled: boolean;
  draft: boolean;
  promoted: boolean;
  position: number;
  vote_sum: number;
  vote_count: number;
  section_id: number;
  created_at: string;
  updated_at: string;
  name: string;
  title: string;
  source_locale: string;
  locale: string;
  outdated: boolean;
  outdated_locales: any[];
  edited_at: string;
  user_segment_id: null | number;
  permission_group_id: number;
  label_names: string[];
  body: string;
}

export interface IArticleVote {
  up: number;
  down: number;
  total: number;
}

export interface ISearchedArticle extends IArticleProps {
  snippet: string;
}

export interface IArticleSearchResult {
  count: number;
  next_page: string | null; // next page url
  page: number;
  page_count: number;
  per_page: number;
  previous_page: string | null; // prev page url
  results: ISearchedArticle[];
}

export interface ISearchArticlesParams extends IZendeskPaginationParams {
  label_names?: string;
  query?: string;
  locale?: string;
  // category section label_names
}

export interface IZendeskPaginationParams {
  per_page?: number;
  page?: number;
}

export interface IArticleParams {
  label_names?: string[] | string;
  sort_by?: "position" | "title" | "created_at" | "updated_at";
  sort_order?: "asc" | "desc";
}

export interface IArticleSearchParams extends IZendeskPaginationParams {
  label_names?: string[] | string;
  query?: string;
  section?: string;
  draft?: boolean;
  t?: number; // force refresh
  locale?: string;
}

export interface ILikeButtonProps {
  color?: string;
  isToggled?: boolean | null;
  onClick?: Function;
  className?: string;
}

export interface IArticleSearchProps {
  articleId: string;
  title: string;
  locale?: string;
}

export interface MostSearchArticles {
  articleId: string;
  title: string;
  views: string;
  status: string;
}

export type ArticleSortBy = "title" | "created_at" | "updated_at" | "edited_at";
export type ArticleSortOrder = "asc" | "desc";

export interface UseGetArticlesByLabelsParams {
  labels: string[];
  excludedLabels?: string[];
  page?: number;
  limit?: number;
  sortBy?: ArticleSortBy;
  sortOrder?: ArticleSortOrder;
  locale?: string;
}

export interface GetArticlesByLabelsData {
  articles: IArticleProps[];
  count: number;
  next_page: number;
  page: number;
  page_count: number;
  per_page: number;
  previous_page: number;
  sort_by: ArticleSortBy;
  sort_order: ArticleSortOrder;
}
